import { Button } from '@material-ui/core';
import ArrowBack from '@material-ui/icons/ArrowBack';
import React, { memo } from 'react';
import styled from 'styled-components';
import { texts } from '../../constants/texts';
import { HelpIcon } from '../../imports/ui-parts';
import { ButtonStateType } from '../../imports/utils';

const Root = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const ButtonWrapper = styled.div`
  padding: 5px;
`;

const ButtonText = styled.div`
  padding: 0 5px;
  white-space: nowrap;
`;

export const OtherButtons = memo(
  ({
    inferButtonState = 'hide',
    onInferClick,
    openSettingsDialogButtonState = 'hide',
    onSettingsDialogClick,
    onBackToListClick,
    onHelpClick
  }: Readonly<{
    inferButtonState: ButtonStateType;
    onInferClick: () => void;
    openSettingsDialogButtonState: ButtonStateType;
    onSettingsDialogClick: () => void;
    onBackToListClick: () => void;
    onHelpClick: () => void;
  }>) => (
    <Root>
      <ButtonWrapper>
        <Button variant='contained' size='medium' onClick={onBackToListClick}>
          <ArrowBack />
          <ButtonText>{texts.toolbar.otherButtons.backToListPage}</ButtonText>
        </Button>
      </ButtonWrapper>

      <ButtonWrapper>
        <Button variant='contained' size='medium' onClick={onHelpClick}>
          <HelpIcon />
          <ButtonText>{texts.toolbar.otherButtons.helpButton}</ButtonText>
        </Button>
      </ButtonWrapper>

      {openSettingsDialogButtonState !== 'hide' ? (
        <ButtonWrapper>
          <Button
            variant='contained'
            color='primary'
            size='medium'
            onClick={onSettingsDialogClick}
            disabled={openSettingsDialogButtonState === 'disabled'}
          >
            <ButtonText>
              {texts.toolbar.otherButtons.settingsDialogButton}
            </ButtonText>
          </Button>
        </ButtonWrapper>
      ) : (
        undefined
      )}

      {inferButtonState !== 'hide' ? (
        <ButtonWrapper>
          <Button
            variant='contained'
            color='primary'
            size='medium'
            onClick={onInferClick}
            disabled={inferButtonState === 'disabled'}
          >
            <ButtonText>{texts.toolbar.otherButtons.inferButton}</ButtonText>
          </Button>
        </ButtonWrapper>
      ) : (
        undefined
      )}
    </Root>
  )
);

OtherButtons.displayName = 'OtherButtons';
